import { ContextTagKeys } from '../Interfaces/Contracts/Generated/ContextTagKeys';
var PartAExtensions = /** @class */ (function () {
    function PartAExtensions(mapTags) {
        this.UserExtensionName = "User";
        this.WebExtensionName = "Web";
        this.AppExtensionName = "App";
        // Approved tags in 4.0
        this.accountIdTag = "User.AccountId";
        this.userTagsKeysMap = {};
        // user.tags mapping
        this.userTagsKeysMap[this.accountIdTag] = mapTags.userAccountId;
        this.ctxKeys = { id: "id", authId: "authId", localId: "localId" };
        // user.ctx mapping
        this.userExtKeysMap = {};
        this.userExtKeysMap[this.ctxKeys.localId] = mapTags.userId;
        this.userExtKeysMap[this.ctxKeys.authId] = mapTags.userAuthUserId;
    }
    return PartAExtensions;
}());
export { PartAExtensions };
var kys = new ContextTagKeys();
export var partAExtensions = new PartAExtensions(kys); // export global instance
//# sourceMappingURL=PartAExtensions.js.map